<div class="switch" [ngClass]="{ 'switch-lg': large }">
    <input type="checkbox" id="toggle-{{ id }}" [disabled]="disable" [(ngModel)]="value" />
    <label class="togglemark" for="toggle-{{ id }}" aria-label="Toggle"></label>
</div>
